export default {
	moralis: {
		appId: "yNJK1ebYItsI7oTu1wgM7mvHGb5cd3zeyl2n13hz",
		serverUrl: "https://z3hqonhwoq7t.usemoralis.com:2053/server"
	}
};